import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { ROLES } from '@/constants'

Vue.use(VueRouter)

const routes = [
  // 公开页面 - 活动门户
  {
    path: '/',
    name: 'Landing',
    component: () => import('@/views/portal/Landing.vue'),
    meta: { title: '首页', requiresAuth: false }
  },
  {
    path: '/news',
    name: 'NewsList',
    component: () => import('@/views/portal/NewsList.vue'),
    meta: { title: '活动动态', requiresAuth: false }
  },
  {
    path: '/news/:id',
    name: 'NewsDetail',
    component: () => import('@/views/portal/NewsDetail.vue'),
    meta: { title: '新闻详情', requiresAuth: false }
  },

  // 认证相关
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { title: '登录', requiresAuth: false }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/auth/Register.vue'),
    meta: { title: '注册', requiresAuth: false }
  },

  // C端 - 学生用户中心
  {
    path: '/user',
    component: () => import('@/layouts/UserLayout.vue'),
    meta: { requiresAuth: true, roles: [ROLES.STUDENT] },
    children: [
      {
        path: 'auth',
        name: 'UserAuth',
        component: () => import('@/views/user/Auth.vue'),
        meta: { title: '实名认证' }
      },
      {
        path: 'enroll',
        name: 'Enroll',
        component: () => import('@/views/user/Enroll.vue'),
        meta: { title: '活动报名' }
      },
      {
        path: 'console',
        name: 'Console',
        component: () => import('@/views/user/Console.vue'),
        meta: { title: '个人控制台' }
      },
      {
        path: 'material/submit',
        name: 'MaterialSubmit',
        component: () => import('@/views/user/MaterialSubmit.vue'),
        meta: { title: '提交初赛材料' }
      },
      {
        path: 'works',
        name: 'MyWorks',
        component: () => import('@/views/user/MyWorks.vue'),
        meta: { title: '我的作品' }
      },
      {
        path: 'works/:id',
        name: 'WorkDetail',
        component: () => import('@/views/user/WorkDetail.vue'),
        meta: { title: '作品详情' }
      }
    ]
  },

  // B端 - 老师工作台
  {
    path: '/teacher',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true, roles: [ROLES.TEACHER, ROLES.SCHOOL_ADMIN] },
    // redirect: (to) => {
    //   const roleCode = store.getters.roleCode
    //   // 校区管理员默认跳转到校区看板
    //   if (roleCode === ROLES.SCHOOL_ADMIN) {
    //     return '/teacher/dashboard'
    //   }
    //   // 普通老师跳转到工作台
    //   return '/teacher'
    // },
    children: [
      {
        path: '',
        name: 'TeacherWorkbench',
        component: () => import('@/views/teacher/Workbench.vue'),
        meta: { title: '老师工作台' }
      },
      {
        path: 'dashboard',
        name: 'SchoolDashboard',
        component: () => import('@/views/teacher/SchoolDashboard.vue'),
        meta: { title: '校区看板', roles: [ROLES.SCHOOL_ADMIN] }
      },
      {
        path: 'works',
        name: 'SchoolWorksManagement',
        component: () => import('@/views/teacher/SchoolWorksManagement.vue'),
        meta: { title: '作品推荐', roles: [ROLES.TEACHER, ROLES.SCHOOL_ADMIN] }
      },
      {
        path: 'review/:id',
        name: 'ReviewDetail',
        component: () => import('@/views/teacher/ReviewDetail.vue'),
        meta: { title: '审核详情' }
      }
    ]
  },

  // 认证流程（独立布局，不需要登录）
  {
    path: '/auth',
    component: () => import('@/layouts/AuthLayout.vue'),
    meta: { requiresAuth: false },
    children: [
      {
        path: 'teacher/admin',
        name: 'TeacherAuthAdmin',
        component: () => import('@/views/teacher/AuthAdmin.vue'),
        meta: { title: '学校管理员认证' }
      },
      {
        path: 'teacher/normal',
        name: 'TeacherAuthNormal',
        component: () => import('@/views/teacher/AuthNormal.vue'),
        meta: { title: '普通老师认证' }
      }
    ]
  },

  // B端 - 管理后台
  {
    path: '/admin',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: { requiresAuth: true, roles: [ROLES.DISTRICT_ADMIN, ROLES.CITY_ADMIN, ROLES.ORGANIZER] },
    children: [
      {
        path: '',
        name: 'AdminDashboard',
        component: () => import('@/views/admin/Dashboard.vue'),
        meta: { title: '数据看板', roles: [ROLES.DISTRICT_ADMIN, ROLES.CITY_ADMIN] }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: () => import('@/views/admin/UserManagement.vue'),
        meta: { title: '用户管理' }
      },
      {
        path: 'schools',
        name: 'SchoolManagement',
        component: () => import('@/views/admin/SchoolManagement.vue'),
        meta: { title: '学校管理' }
      },
      {
        path: 'works',
        name: 'WorksManagement',
        component: () => import('@/views/admin/WorksManagement.vue'),
        meta: { title: '作品管理' }
      },
      {
        path: 'contest',
        name: 'ContestConfig',
        component: () => import('@/views/admin/ContestConfig.vue'),
        meta: { title: '活动配置' }
      },
      {
        path: 'districts',
        name: 'DistrictManagement',
        component: () => import('@/views/admin/DistrictManagement.vue'),
        meta: { title: '地区管理', roles: [ROLES.ORGANIZER] }
      },
      {
        path: 'news',
        name: 'NewsManagement',
        component: () => import('@/views/admin/NewsList.vue'),
        meta: { title: '资讯管理' }
      },
      {
        path: 'news/add',
        name: 'NewsAdd',
        component: () => import('@/views/admin/NewsEdit.vue'),
        meta: { title: '新增资讯' }
      },
      {
        path: 'news/edit/:id',
        name: 'NewsEdit',
        component: () => import('@/views/admin/NewsEdit.vue'),
        meta: { title: '编辑资讯' }
      },
      {
        path: 'news/detail/:id',
        name: 'NewsDetailAdmin',
        component: () => import('@/views/admin/NewsDetail.vue'),
        meta: { title: '资讯详情' }
      }
    ]
  },

  // 404
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/**
 * 判断路由是否需要登录
 * @param {Object} route - 路由对象
 * @returns {boolean}
 */
const requiresLogin = (route) => {
  // 检查当前路由或其父路由是否需要认证
  let requiresAuth = route.meta.requiresAuth;
  if (requiresAuth === undefined && route.matched.length > 0) {
    for (let i = route.matched.length - 1; i >= 0; i--) {
      if (route.matched[i].meta.hasOwnProperty('requiresAuth')) {
        requiresAuth = route.matched[i].meta.requiresAuth;
        break;
      }
    }
  }
  return !!requiresAuth;
};

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 家庭实验室评选活动` : '家庭实验室评选活动'

  const isLoggedIn = store.getters.isLoggedIn
  const roleCode = store.getters.roleCode
  

  
  // 检查当前路由或其父路由是否需要认证
  // 如果当前路由没有requiresAuth，则检查其父路由
  let requiresAuth = to.meta.requiresAuth;
  if (requiresAuth === undefined && to.matched.length > 0) {
    // 遍历匹配的路由，查找最近的父路由是否有requiresAuth设置
    for (let i = to.matched.length - 1; i >= 0; i--) {
      if (to.matched[i].meta.hasOwnProperty('requiresAuth')) {
        requiresAuth = to.matched[i].meta.requiresAuth;
        break;
      }
    }
  }
  // 需要登录的页面
  if (requiresAuth) {
    if (!isLoggedIn) {  // 检查用户是否已登录
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
      return
    } else {
      // 将认证状态检查改为异步执行，避免在路由守卫中直接跳转
      setTimeout(() => {
        // 认证状态校验 - 从本地存储获取用户信息
        const homelabUserInfo = localStorage.getItem('homelab_user_info');
        if (homelabUserInfo) {
          try {
            const userInfo = JSON.parse(homelabUserInfo);
            const { roleCode, authStatus, teacherAuth, schoolAdminAuth } = userInfo;


            // 根据角色和认证状态进行跳转判断
            if (roleCode === 'TEACHER') {
              if (!teacherAuth || teacherAuth.status === 'PENDING' || teacherAuth.status === 'REJECTED') {
                // 如果是老师但未认证、待审核或被拒绝，且目标不是认证页面，则跳转到认证页面
                if (to.name !== 'TeacherAuthNormal' && !to.path.startsWith('/auth/')) {
                  router.push({ name: 'TeacherAuthNormal' });
                  return;
                }
              } else {
                // 如果老师已认证，但尝试访问认证页面，则重定向到工作台
                if (to.name === 'TeacherAuthNormal' && teacherAuth.status === 'APPROVED') {
                  router.push({ name: 'TeacherWorkbench' });
                  return;
                }
              }
            } else if (roleCode === 'SCHOOL_ADMIN') {
              if (!schoolAdminAuth || Object.keys(schoolAdminAuth).length === 0 || schoolAdminAuth.status === 'PENDING' || schoolAdminAuth.status === 'REJECTED') {
                // 如果是学校管理员但未认证、认证为空对象、待审核或被拒绝，且目标不是认证页面，则跳转到认证页面
                if (to.name !== 'TeacherAuthAdmin' && !to.path.startsWith('/auth/')) {
                  router.push({ name: 'TeacherAuthAdmin' });
                  return;
                }
              } else {
                // 如果学校管理员已认证，但尝试访问认证页面，则重定向到仪表盘
                if (to.name === 'TeacherAuthAdmin' && schoolAdminAuth.status === 'APPROVED') {
                  router.push({ name: 'SchoolDashboard' });
                  return;
                }
              }
            } else if (roleCode === 'STUDENT') {

              if (!authStatus || authStatus === 'UN_AUTH') {
                // 如果是学生但未认证，且目标不是认证页面，则跳转到学生认证页面
                if (to.name !== 'UserAuth' && !to.path.startsWith('/auth/') && to.name !== 'Console') {
                  router.push({ name: 'UserAuth' });
                  return;
                }
              } else {
                // 如果学生已认证，但尝试访问认证页面，则重定向到控制台
                if (to.name === 'UserAuth' && authStatus === 'AUTH_SUCCESS') {
                  router.push({ name: 'Console' });
                  return;
                }
              }
            }
          } catch (error) {
            console.error('解析用户信息失败:', error);
          }
        }
      }, 300); // 延迟执行，避免与当前路由导航冲突
    }

    // 权限校验
    if (to.meta.roles && !to.meta.roles.includes(roleCode)) {
      // 组委会角色访问受限页面时，重定向到用户管理
      if (roleCode === ROLES.ORGANIZER) {
        next('/admin/users')
      } else {
        next('/')
      }
      return
    }
  }

  // 已登录用户访问登录/注册页，重定向到对应首页
  if (isLoggedIn && (to.path === '/login' || to.path === '/register')) {
    // 根据角色重定向到不同的首页
    const roleRedirects = {
      [ROLES.SCHOOL_ADMIN]: '/teacher/dashboard',
      [ROLES.TEACHER]: '/teacher',
      [ROLES.STUDENT]: '/user/console',
      [ROLES.DISTRICT_ADMIN]: '/admin',
      [ROLES.CITY_ADMIN]: '/admin',
      [ROLES.ORGANIZER]: '/admin/users'
    }
    next(roleRedirects[roleCode] || '/')
    return
  }

  next()
})

export default router
